import { NgModule } from '@angular/core';
import { ScrollViewportComponent } from './scroll-viewport.component';
import { DefaultScrollStrategyDirective } from './default-scroll-strategy';

@NgModule({
    declarations: [ScrollViewportComponent, DefaultScrollStrategyDirective],
    exports: [ScrollViewportComponent, DefaultScrollStrategyDirective]
})
export class ScrollViewportModule {}
